<template>
    <div>
        <input
            type="text"
            :field="column.id"
            v-model="column.search"
            @focus="showPopup"
            @change="$emit('searchProduct')"
            class="search-input"
            :placeholder="'Search'"
            :id="product_id"
            autocomplete="off"
        />

        <Portal to="popup-section">
            <div
                v-if="popupVisibility"
                v-click-outside="hidePopup"
                class="bo-context-menu bo-advanced-filter"
                :style="[
                    {
                        position: 'fixed',
                        display: 'block',
                        top: top + 'px',
                        left: left + 'px',
                    },
                ]"
            >
                <div
                    class="context-item"
                    @click="showSearchModal('product')"
                >
                    <div class="item-command">
                        <i class="icon-inventory"></i>
                        <span>Product</span>
                    </div>

                    <div class="item-hints">
                        <i class="icon-chevronright"></i>
                    </div>
                </div>

                <div
                    class="context-item"
                    v-if="searchProductGroup"
                    @click="showSearchModal('product_group')"
                >
                    <div class="item-command">
                        <i class="icon-groupproduct"></i>
                        <span>Product Group</span>
                    </div>

                    <div class="item-hints">
                        <i class="icon-chevronright"></i>
                    </div>
                </div>
            </div>

            <!-- advance search modal -->
            <div
                class="modal-backdrop fade show"
                v-if="showAdvanceSearch"
            ></div>
            <div
                class="modal bo-modal fade show"
                tabindex="-1"
                role="dialog"
                aria-labelledby="modal-add-new-product"
                aria-hidden="true"
                v-if="showAdvanceSearch"
                style="display: block"
            >
                <div
                    class="modal-dialog modal-dialog-centered"
                    role="document"
                    style="max-width: 90%"
                >
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="modal-title">Advance Search Product</div>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                @click="showAdvanceSearch = false"
                            >
                                <i class="icon-close"></i>
                            </button>
                        </div>
                        <div class="modal-body">
                            <!-- TAB NAV -->
                            <ul
                                class="nav nav-tabs bo-nav"
                                id="tab-add-products"
                                role="tablist"
                            >
                                <!-- NAV - ALL -->
                                <li
                                    v-if="searchProductGroup"
                                    class="nav-item"
                                    @click="changeTab('all')"
                                >
                                    <a
                                        :class="['nav-link', { active: currentTab == 'all' }]"
                                        id="tab-all-products"
                                        data-toggle="tab"
                                        href="#all-products"
                                        role="tab"
                                        aria-controls="all-products"
                                        aria-selected="true"
                                    >
                                        <span>All</span>
                                        <span class="badge">{{ totalAllProducts }}</span>
                                    </a>
                                </li>

                                <!-- NAV - PRODUCTS -->
                                <li
                                    class="nav-item"
                                    @click="changeTab('product')"
                                >
                                    <a
                                        :class="['nav-link', { active: currentTab == 'product' }]"
                                        id="tab-products"
                                        data-toggle="tab"
                                        href="#products"
                                        role="tab"
                                        aria-controls="products"
                                        aria-selected="true"
                                    >
                                        <span>Products</span>
                                        <span class="badge">{{ totalProducts }}</span>
                                    </a>
                                </li>

                                <!-- NAV - PRODUCT GROUPS -->
                                <li
                                    v-if="searchProductGroup"
                                    class="nav-item"
                                    @click="changeTab('product_group')"
                                >
                                    <a
                                        :class="[
                                            'nav-link',
                                            {
                                                active: currentTab == 'product_group',
                                            },
                                        ]"
                                        id="tab-product-groups"
                                        data-toggle="tab"
                                        href="#product-groups"
                                        role="tab"
                                        aria-controls="product-groups"
                                        aria-selected="true"
                                    >
                                        <span>Product Groups</span>
                                        <span class="badge">{{ totalProductGroups }}</span>
                                    </a>
                                </li>
                            </ul>

                            <div class="tab-content tab-content-add-products">
                                <div
                                    class="tab-pane fade show active"
                                    id="all-products"
                                    role="tabpanel"
                                    aria-labelledby="tab-all-products"
                                >
                                    <bo-datatable
                                        ref="advanceSearchProduct"
                                        :select-single-record="selectSingleProduct"
                                        :columns="advanceSearchColumns"
                                        :get-products-url="advanceSearchUrl"
                                        :get-select-options-url="advanceSearchOptionsUrl"
                                        :without-product-advance-search="withoutProductAdvanceSearch"
                                        v-on:updateSelectedRecords="updateSelectedRecords"
                                        :skipPortal="skipPortal"
                                    ></bo-datatable>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer d-flex justify-content-between">
                            <div class="selections">
                                <div class="total-selected"></div>
                            </div>
                            <div class="buttons">
                                <button
                                    type="button"
                                    class="btn btn-rounded light"
                                    data-dismiss="modal"
                                    ref="closebutton"
                                    @click="showAdvanceSearch = false"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-rounded arclight"
                                    data-dismiss="modal"
                                    @click="proceedAdvanceSearch"
                                >
                                    Search
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Portal>
    </div>
</template>

<script>
import Vue from "vue";
import vClickOutside from "v-click-outside";
Vue.use(vClickOutside);
import UniqueId from "vue-unique-id";
Vue.use(UniqueId);
import PortalVue from "portal-vue";
Vue.use(PortalVue);

export default {
    props: ["column", "parentId"],

    data() {
        return {
            selectSingleProduct: true,
            product_id: this.$id("product"),
            searchProductGroup: true,
            showAdvanceSearch: false,
            popupVisibility: false,

            currentTab: "product",
            advanceSearchColumns: this.$attrs["advanceSearchColumns"],
            advanceSearchUrl: this.$attrs["advanceSearchProductUrl"],
            advanceSearchOptionsUrl: this.$attrs["advanceSearchProductOptionsUrl"],

            withoutProductAdvanceSearch: true,
            products: [],
            productgroups: [],
            top: 0,
            left: 0,
            skipPortal: true,
        };
    },

    computed: {
        totalProducts: function () {
            return this.products.length;
        },
        totalProductGroups: function () {
            return this.productgroups.length;
        },
        totalAllProducts: function () {
            return this.products.length + this.productgroups.length;
        },
    },

    created() {},

    mounted() {
        window.addEventListener("resize", this.setPopupPosition);
        window.addEventListener("scroll", this.setPopupPosition);

        let parent = this.$parent;
        while (parent) {
            parent.$el.addEventListener("scroll", this.setPopupPosition);
            parent = parent.$parent;
        }

        if (typeof this.column.searchProductGroup !== "undefined") {
            this.searchProductGroup = this.column.searchProductGroup;
        }
    },

    methods: {
        setPopupPosition() {
            var elem_position = document.getElementById(this.product_id).getBoundingClientRect();
            this.top = elem_position.y + elem_position.height + 5;
            this.left = elem_position.x;
        },

        showPopup() {
            if (this.column.advanceSearch !== false) {
                this.setPopupPosition();

                this.popupVisibility = true;
                this.$forceUpdate();
            }
        },

        hidePopup(event) {
            if (this.product_id != event.target.id) {
                this.popupVisibility = false;
                this.$forceUpdate();
            }
        },

        hideAdvanceSearch(event) {
            this.showAdvanceSearch = false;
        },

        showSearchModal(tab) {
            this.popupVisibility = false;
            this.showAdvanceSearch = true;
            this.currentTab = tab;
        },

        changeTab(clickedTab) {
            if (clickedTab != this.currentTab) {
                this.currentTab = clickedTab;
                this.$emit("searchProduct", [{ key: "product_type", value: this.currentTab }]);
                this.$refs.advanceSearchProduct.selectablePrefix = this.currentTab + "_";
            }
        },

        updateSelectedRecords(records) {
            this.products = [];
            this.productgroups = [];
            records.forEach((record) => {
                var index = record.indexOf("product_group");
                if (0 === index) {
                    this.productgroups.push(record.replace("product_group_", ""));
                } else {
                    this.products.push(record.replace("product_", ""));
                }
            });
        },

        proceedAdvanceSearch() {
            this.showAdvanceSearch = false;
            this.$emit("advanceSearch", this.$refs.advanceSearchProduct.selectedRow);
        },
    },
};
</script>
